import React from 'react';

export default class ContextProvider {
  static userContext = React.createContext();
}
